import styled from 'styled-components';

export const Heading1 = styled.h1`
  font-family: 'Haffer', sans-serif;
  font-weight: 300;
  font-size: 3.75rem;
  line-height: 1.2;
  margin: 0.75rem 0;
`;

export const Heading2 = styled.h2`
  font-family: 'Haffer', sans-serif;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.2;
  margin-top: 2rem;
`;

export const Heading3 = styled.h3`
  font-family: 'Haffer', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.2;
`;

export const Paragraph = styled.p`
  font-family: 'Haffer', sans-serif;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
`;

export const BigParagraph = styled(Paragraph)`
  font-size: 1.4rem;
  line-height: 1.4;
  font-weight: 300;
`;

export const Label = styled.p`
  font-family: 'Haffer', sans-serif;
  font-size: 0.75rem;
  line-height: 1.2;
  margin: 0;
  font-weight: 500;
  text-transform: uppercase;
`;

export const Subheading = styled.p`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.2;
`;

export const Detail = styled.p`
  font-family: 'Haffer', sans-serif;
  font-weight: normal;
  font-size: 0.75rem;
  line-height: 1.2;
`;

export const Ingress = styled.p`
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: normal;
`;
